import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Link } from 'foundations-components/transitional/components/Link';
import { SectionSubTitle } from 'pricing-pages-ui-components/semantic/PageSection';
import { getAccountDashboardUrl } from 'self-service-api/core/utilities/links';
import { MERCH_CARD } from '../../../../v2/constants/tracking/TrackingSources';
import { useHasApiNameInProductInventory } from '../../../hooks/inventory/useProductInventoryLookup';
import { isValidApiName } from '../../../utils/typeguards';

/**
 * This is exclusively used within the merch card components.
 * It is used to display the subheading of a merch card.
 *
 * @param Subheading - The subheading of the merch card.
 * @returns A text component with the subheading of the merch card.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const MerchCardSubheadingContainer = ({
  Subheading,
  apiName
}) => {
  const validApiName = isValidApiName(apiName) ? apiName : undefined;
  const {
    hasProductInInventory
  } = useHasApiNameInProductInventory({
    apiName: validApiName
  });
  if (!validApiName || !hasProductInInventory) {
    return /*#__PURE__*/_jsx(SectionSubTitle, {
      children: Subheading
    });
  }
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    children: /*#__PURE__*/_jsx(Link, {
      href: getAccountDashboardUrl(),
      "data-selenium-id": `${MERCH_CARD}-${validApiName}-VIEW_ACCOUNT-button`,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.viewAccountButton.text"
      })
    })
  });
};